import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const SettingContext = createContext()

const SettingProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllConfigDetails = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/admin/system/configuration/details`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const updateConfigDetails = async (settingDetails) => {
        try {
            const { data } = await axios.put(`${baseURL}/admin/system/configuration/update`, settingDetails, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast({ title: 'Please fill all mandatory fields.', position: 'top', status: 'error', isClosable: true });
                    } else {
                        toast({ title: errors[0].msg, position: 'top', status: 'error', isClosable: true });
                    }
                }
            } else {
                toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
            }
        }
    }

    return (
        <SettingContext.Provider value={{ getAllConfigDetails, updateConfigDetails }}>
            {children}
        </SettingContext.Provider>
    )
}

const useSetting = () => useContext(SettingContext)

export { useSetting, SettingProvider }